import req from './../../../fetch';
import { undocumentedResponse } from './../../../utils';
import {
  AllAPIResponses,
  CarbonError,
  CarbonQueryResult,
  NodeType,
  CarbonQueryBodyType,
} from './../../../index';

type ResponseType = CarbonQueryResult<NodeType>;
const post = async (
  payload: CarbonQueryBodyType,
  headers?: Headers
): Promise<AllAPIResponses<ResponseType>> => {
  try {
    const resp = await req.post(
      `/api/nodes/query`,
      JSON.stringify(payload),
      headers
    );
    const clone = resp.clone();
    switch (resp.status) {
      case 200:
        return {
          data: (await resp.json()) as ResponseType,
          response: clone,
        };
      case 400:
      case 401:
      case 403:
      case 404:
      case 500:
        return {
          error: (await resp.json()) as CarbonError,
          response: clone,
        };
      default:
        return {
          error: new Error(undocumentedResponse(resp)),
          response: clone,
        };
    }
  } catch (e) {
    return { error: e, response: undefined };
  }
};

export default post;
